import { Component, OnInit, ViewChild, Input, forwardRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { ModalComponent } from 'core/components';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ImageConversionService } from 'core/services/image-conversion.service';
import { NgIf, NgStyle } from '@angular/common';
import { DirectivesModule } from '@directives/directives.module';
import { ImageCropperModule } from 'core/components/image-selector/image-cropper.module';
import { ModalSplatComponent } from 'core/components/modal-splat/modal-splat.component';

@Component({
  selector: 'lms-image-selector',
  templateUrl: './image-selector.component.html',
  styleUrls: ['./image-selector.component.scss'],
  standalone: true,
  imports: [
    ImageCropperComponent,
    ImageCropperModule,
    DirectivesModule,
    NgIf,
    NgStyle,
    forwardRef(() => ModalSplatComponent)
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: ImageSelectorComponent, multi: true }],
  hostDirectives: []
})
export class ImageSelectorComponent implements OnInit, ControlValueAccessor {
  @Input() public isDisabled: boolean;
  @Input() data: any = {};
  @Input() label: string;
  @Input() action: string;
  @Input() maxSizeInMB: number;
  public cardImage: string;
  public previewFile: any;
  public croppedImage: any = '';

  @ViewChild('modalImageSelector', { static: false })
  public modalImageSelector: ModalComponent;

  public propagateChange = (_: any) => {};
  public propagateTouched = (_: any) => {};

  constructor() {}

  ngOnInit(): void {
    this.cardImage = this.getCardImage();
  }

  getCardImage(): any {
    if (this.data.saved) {
      return this.data.saved;
    }
    return null;
  }

  writeValue(value: any): void {
    setTimeout(() => {
      this.data = value ? value : {};
      this.cardImage = this.getCardImage();
    }, 100);
  }

  registerOnChange(fn): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn): void {
    this.propagateTouched = fn;
  }

  imageCropped(event: ImageCroppedEvent): void {
    try {
      this.croppedImage = event.base64;
    } catch (error) {
      console.error('Image cropping failed:', error);
    }
  }

  imageLoaded() {}
  cropperReady() {}
  loadImageFailed(event: any) {
    console.error('Image loading failed:', event);
  }

  changeImage() {
    this.cardImage = this.croppedImage;
    this.data.image = this.cardImage;
    this.propagateChange(this.data);
    this.closeModal();
  }

  removeImage(): void {
    this.cardImage = null;
    this.data.image = null;
    this.propagateChange(this.data);
  }

  openModal(): void {
    this.modalImageSelector.open();
  }

  closeModal(): void {
    this.modalImageSelector.close();
    this.previewFile = null;
  }

  onGetFile(event: any): void {
    if ((event && event[0]) || event.target.files) {
      const selectedFile: File = event[0] ? event[0] : event.target.files[0];

      if (
        ImageConversionService.isImageValid(selectedFile, {
          size: this.maxSizeInMB
        })
      ) {
        this.previewFile = selectedFile;
      }
    }
  }
}
